import {
  useLatestAgentDigestEventData,
  getAgentDigestEventContent,
} from "@/mds/components/sessions/session-notification/session-notification.utils";
import { SessionEvent, SessionPartKind } from "@/mds/components/sessions/session.types";
import { first } from "lodash-es";
import styled from "@emotion/styled";

type Props = {
  sessionEvents: SessionEvent[];
};

// TODO: Reuse this for Chrome notifications
export const MDSSessionNotificationContent = ({ sessionEvents }: Props) => {
  const agentDigestData = useLatestAgentDigestEventData({ sessionEvents });
  const digestParts = agentDigestData?.value.parts ?? [];
  const part = first(digestParts);

  if (!part || part?.kind !== SessionPartKind.MarkdownV1) {
    return <FallbackContent />;
  }

  return <Content>{getAgentDigestEventContent({ content: part.content })}</Content>;
};

const FallbackContent = () => {
  return <Content>Mem finished processing</Content>;
};

const Content = styled.div`
  color: ${({ theme }) => theme.colors.grey.x600};
  font-size: ${({ theme }) => theme.fontSizes.smedium};
  line-height: ${({ theme }) => theme.lineHeights.smedium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  padding: 0 ${({ theme }) => theme.spacing.sm};
`;
